import React from "react";
import { Container, Row, Col } from "reactstrap";

import MasterPage from "../../MasterPage";
import Loading from "../../../components/Loading";
import Divider from "../../../components/Divider";
import Autoparts from "../../../components/nami/Autoparts";
import Search from "../../../components/Search";
import AutopartFilters from "../../../components/nami/AutopartFilters";
import Filters from "../../../components/Filters";

import "./style.css";

class AutopartsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: [],
    };
  }

  componentDidMount() {
    document.title = "Autopartes";
  }

  render() {
    const {
      windowSize,
      showAutoparts,
      autopartsIsLoading,
      pag,
      rowsMax,
      resultCount,
      current,
      history,
      autoparts,
      classes,
      user,
      setCurrent,
      toggleAdd,
    } = this.props;
    const { messages } = this.state;
    const isLoggedIn = !!user;
    const isSeller = user ? user.isSeller : false;

    return (
      <MasterPage contentPaddingTop={false}>
        {showAutoparts ? (
          autopartsIsLoading ? (
            <Loading />
          ) : (
            <div>
              <Container>
                <br />
                <br />
                Buscar por texto:
                <br />
                <br />
                <div className="categories-brands-search">
                  <Search loadFromUrl history={history} link={"/productos"} />
                </div>
              </Container>
              <br />
              <br />
              <Divider min />
              <br />
              <br />
              <Container className="autoparts-container">
                <Row>
                  <Col xs="8" lg="2">
                    <div className="d-none d-lg-block">
                      <span>{`${resultCount} resultados`}</span>
                      <Divider min marginTop />
                    </div>
                    <Filters loadFromUrl showOrderBy />
                  </Col>
                  <Col
                    xs="4"
                    className="d-block d-lg-none text-right result-count"
                  >
                    {`${resultCount} resultados`}
                  </Col>
                  <Col md="12" lg="10">
                    <Autoparts
                      isLoggedIn={isLoggedIn}
                      isSeller={isSeller}
                      pag={pag}
                      rowsMax={rowsMax}
                      windowSize={windowSize}
                      resultCount={resultCount}
                      current={current}
                      items={autoparts}
                      classes={classes}
                      user={user}
                      cartAddItem={this.cartAddItem}
                      setCurrent={setCurrent}
                      toggleAdd={toggleAdd}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
          )
        ) : (
          <div className="categories-brands">
            <Container>
              <br />
              <br />
              Buscar por texto:
              <br />
              <br />
              <div className="categories-brands-search">
                <Search loadFromUrl history={history} link={"/productos"} />
              </div>
            </Container>
            <br />
            <br />
            <Divider />
            <Container>
              Busqueda avanzada:
              <br />
              <br />
              <AutopartFilters />
            </Container>
          </div>
        )}
        {messages.map((message, i) => {
          return <div key={i}>{message}</div>;
        })}
      </MasterPage>
    );
  }
}

export default AutopartsPage;
